<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script setup>
import { onMounted, watch } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import { initializeAuth0 } from "@/services/AuthService";
import { useAuthStore } from "./store/authStore";

const { getAccessTokenSilently, isAuthenticated } = useAuth0();
const authStore = useAuthStore();

onMounted(() => {
  initializeAuth0();
});

watch(
  isAuthenticated,
  async (authenticated) => {
    try {
      if (!authenticated) return;

      const token = await getAccessTokenSilently({
        ignoreCache: true,
        authorizationParams: {
          audience: process.env.VUE_APP_AUTH0_AUDIENCE,
        },
      });

      const payload = parseJwt(token);
      authStore.setPermissions(payload.permissions || []);
    } catch (error) {
      console.error("Could not initialize auth.", error);
    }
  },
  { immediate: true }
);

function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  return JSON.parse(atob(base64));
}

</script>

<style>
#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
}

html, body {
  font-family: 'Inter', sans-serif;
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden !important;
}
</style>